import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

const ACCEPTED_FORMATS = ['DD.MM.YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'];

@Pipe({
  name: 'normalizedDate',
})
export class NormalizedDatePipe implements PipeTransform {
  transform(date: string | moment.Moment | null | undefined, format: string = 'DD.MM.YYYY'): string {
    if (date == null) {
      return '';
    }

    const normalized = moment(date, ACCEPTED_FORMATS, true);

    if (!normalized.isValid()) {
      console.warn(`Invalid date format: ${date}`);
      return date.toString();
    }

    return normalized.format(format);
  }
}
